var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0851 17.0833H6.08152C2.07972 17.0833 0.75 15.0465 0.75 13V4.83333C0.75 1.76841 2.07972 0.75 6.08152 0.75H14.0851C18.087 0.75 19.4167 1.76841 19.4167 4.83333V13C19.4167 16.0649 18.0743 17.0833 14.0851 17.0833Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.792 14.2648L19.709 12.2208V5.60656L22.792 3.56253C24.3002 2.56673 25.5423 3.17469 25.5423 4.92522V12.9126C25.5423 14.6631 24.3002 15.2711 22.792 14.2648Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 7.75C15.1325 7.75 15.916 6.9665 15.916 6C15.916 5.0335 15.1325 4.25 14.166 4.25C13.1995 4.25 12.416 5.0335 12.416 6C12.416 6.9665 13.1995 7.75 14.166 7.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOn);
export default __webpack_public_path__ + "static/media/video-on.a0ade2657a7d02aaba5534979efb9c4a.svg";
export { ForwardRef as ReactComponent };